import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import store from "./redux/store";
import {SnackbarProvider} from "notistack";

const container = document.getElementById("root");
const root = createRoot(container); // 👈 React 18 API

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <SnackbarProvider maxSnack={3}  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}>
                <App />
                </SnackbarProvider>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
);
